import TypeDetailController from './type.detail.controller';

export default {
    template: require('./type.detail.tpl.html'),
    controller: TypeDetailController,
    bindings: {}
};
